<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-warn-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <h6 class="title"></h6>
                <div class="dialog-body">
                    <div class="dialog-text">
                        <p>系统检测到你暂未组队，请尽快于游戏中创建队伍！</p>
                        <p>或是通过其他玩家分享出的组队链接加入队伍，</p>
                        <p>小队人数满5人后，可获得以下豪华奖励哦</p>
                    </div>

                    <div class="reward-list">
                        <ul>
                            <li v-for="(r,k) in pack_config" :key="r.id">
                                <div class="reward-item"
                                    v-tips="r.id">
                                    <game-item :id="r.id" :num="r.num" :locked="true"></game-item>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>   
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            pack_config : [{name : '',id : 'ML71',num : 35},{name : '',id : 'ML72',num : 1},{name : '',id : 'LJ30',num : 1},{name : '',id : 'E559',num : 2},{name : '',id : 'LE95',num : 9}],
        }
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
    },
}
</script>

<style scoped>
/* share */
.m-warn-modal {
    width: 620px;
    height: 336px;
    background-image: url(~@/assets/images/utils/bg-modal-warn.png);
}

.m-warn-modal h6 {
    /* height: 14px; */
    width: 458px;
    height: 30px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/utils/title-warn.png);
}

.m-warn-modal .dialog-text {
    font-size: 22px;
    color: #c03b20;
    text-align: center;
    word-break: break-all;
}

.dialog-text p{
    margin-bottom: 4px;
}

.reward-list{
    margin-top: 30px;
}

.reward-list ul{
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
}

.reward-list li{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 104px;
    height: 105px;
    background-image: url(~@/assets/images/utils/bg-item.png);
}

.reward-item{
    width: 46px;
    height: 46px;
}

.m-warn-modal .u-btn.copy {
    position: absolute;
    left: 50%;
    bottom: 30px;
    width: 240px;
    height: 80px;
    margin-left: -120px;
    background-image: url(~@/assets/images/utils/btn-copy.png);
}
</style>


// WEBPACK FOOTER //
// src/components/WarnModal/warnModal.vue